import { gql } from "@apollo/client";

export const CHECK = gql`
  query Test {
    test {
      name
    }
  }
`;

export const GET_USER_PROFILE = gql`
  query GetUser {
    checkUserProfile {
      email
      name
      balance
      isOnboarded
      isConfirmed
    }
  }
`;

export const GET_USER_PROFILE_LEVEL = gql`
  query GetUser {
    user {
      id
      profileLevel
      role
    }
  }
`;

export const GET_USER_BALANCE = gql`
  query GetBalance {
    getUserBalance {
      balance
    }
  }
`;
